import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import "@/scss/index.scss";
import "@packages/component-library/style.css";
import "@packages/icon-library/style.css";
import "@packages/color-tokens/style.css";
import "@packages/fonts-library/style.css";
import "swiper/css";
import i18n from "@/i18n";
import { createHead } from "@unhead/vue/client";

import * as Sentry from "@sentry/vue";
import { LoadingDirective } from "@/package/global-directives/vLoading";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://4456948fb28d64fa84dca958f0191732@sentry.iilab.ru/71",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.NODE_ENV,
  enabled: window.location.hostname !== "localhost",
  sendDefaultPii: true,
});

const head = createHead({ init: [{ title: "RC OFFICE" }] });

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(head);
app.directive("loading", LoadingDirective);

app.mount("#app");
